import { api } from './authService';

const expertService = {
  getTimelineData: async (filters = {}) => {
    // filters can have professionType, lehrjahr
    try {
      const response = await api.get('/expert/practice-instructor-timeline', { params: filters });
      return response.data;
    } catch (error) {
      console.error('Error fetching timeline data', error);
      throw error;
    }
  },

  updateExpirationDate: async (id, expirationDate) => {
    await api.put(`/expert/assignments/${id}/expiration`, { expirationDate });
  },

  reassignStudent: async (studentId, newInstructorId, startDate, expirationDate) => {
    await api.post('/expert/assignments/reassign', {
      studentId,
      newInstructorId,
      startDate,
      expirationDate
    });
  }
};

export default expertService;
